import React from 'react';
import PropTypes from 'prop-types';
import styles from './TextDisplay.module.css';

const TextDisplay = ({ id, label, value }) => {
  return (
    <div className={styles.formGroup}>
      <label htmlFor={id} className={styles.textLabel}>{label}</label>
      <div id={id} className={styles.textDisplay}>
        {value || '-'}
      </div>
    </div>  );
};

TextDisplay.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node])
};

export default TextDisplay;